<div aria-label="author info" class="py-2">
  @if (data?.createdBy) {
    <div>
      <label class="font-semibold pr-2">{{ label }}:</label>
      <span>{{ data?.createdBy | userProfileCredentialsByEmail | async }}</span>
    </div>
  }
  @if (data?.createdOn) {
    <div>
      <label class="font-semibold pr-2">Created On:</label>
      <span>{{ data?.createdOn | utcToLocal:'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
  }
  @if (data?.modifiedBy) {
    <div>
      <label class="font-semibold pr-2">Modified By:</label>
      <span>{{ data?.modifiedBy | userProfileCredentialsByEmail | async }}</span>
    </div>
  }
  @if (data?.modifiedOn) {
    <div>
      <label class="font-semibold pr-2">Modified On:</label>
      <span>{{ data?.modifiedOn | utcToLocal:'MM/dd/yyyy hh:mm:ss a' }}</span>
    </div>
  }
</div>
